import { useState } from 'react'
import type { PagerProps } from './Pager'

export function usePagination<T>(rows: readonly T[], resetKey: unknown = null, initialSize = 20) {
  const key = JSON.stringify(resetKey)
  const [state, setState] = useState({ key, page: 1 })
  const [size, setSize] = useState(initialSize)
  const pages = Math.max(1, Math.ceil(rows.length / size))
  const page = Math.min(state.key === key ? state.page : 1, pages)
  return {
    pageRows: rows.slice((page - 1) * size, page * size),
    pager: {
      total: rows.length,
      page,
      size,
      onPage: (p: number) => setState({ key, page: p }),
      onSize: (s: number) => {
        setSize(s)
        setState({ key, page: 1 })
      },
    } satisfies PagerProps,
  }
}
